import { render } from "./ControllerHardware.vue?vue&type=template&id=789d6228"
import script from "./ControllerHardware.vue?vue&type=script&lang=js"
export * from "./ControllerHardware.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__